import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const userByUsername = async ({ commit }, username) => {
  commit('setUserIsFinding', true);
  await connection.get(`/users/${username}/username`)
    .then(res => {
      commit('setUserExist', res.data.data);
      commit('setUserIsFinding', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUserIsFinding', false);
    });
}

export const getUsersList = async ({ commit }) => {
  commit('setUserIsLoading', true);
  let url = `/users/selectable`;

  await connection.get(url)
    .then(res => {
      const users = res.data.data;
      commit('setUsersSelectable', users);
      commit('setUserIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUserIsLoading', false);
    });
}

export const getUsersByCountry = async ({ commit }, countryId) => {
  commit('setUserIsLoading', true);
  let url = `/users/selectable/${countryId}`;

  await connection.get(url)
    .then(res => {
      const users = res.data.data;
      commit('setUsersSelectable', users);
      commit('setUserIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUserIsLoading', false);
    });
}

export const loadUsers = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setUserIsLoading', true);
    let url = `/users`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const users = res.data.data;
        commit('setUsers', users);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setUsersPaginated', res.data);
        commit('setUserIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setUserIsLoading', false);
      });
}

export const userById = async ({ commit }, id) => {
  commit('setUserIsLoading', true);
  await connection.get(`/users/${id}`)
    .then(res => {
      commit('setUserDetail', res.data.data);
      commit('setUserIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUserIsLoading', false);
    });
}

export const storeUser = async ({ commit }, user) => {
  commit('setUserIsCreating', true);
  await connection.post(`/users/create`, user)
    .then(res => {
      commit('saveNewUsers', res.data.data);
      commit('setUserIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUserIsCreating', false);
    });
}

export const updateUser = async ({ commit }, user ) => {
  commit('setUserIsUpdating', true);
  await connection.put(`/users/${user.id}/update`, user)
    .then(res => {
      commit('saveUpdatedUser', res.data);
      commit('setUserIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUserIsUpdating', false);
    });
}

export const deleteUser = async ({ commit }, user) => {
  commit('setUserIsDeleting', true);
  await connection.get(`/users/${user.id}/active`)
    .then(res => {
      commit('setDeleteUser', res.data.data);
      commit('setUserIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUserIsDeleting', false);
    });
}
